// Give namespacing to allow legacy methods to work.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import Config from 'es6/core/config';
import * as API from 'es6/core/api';
import * as Errors from 'es6/core/errors';
import ItemPackage from 'es6/models/item-package';
import { partOfSpeech } from 'es6/helpers/localization';
import Localization from 'es6/services/localization';
import ServerTimeManager from 'es6/services/server-time-manager';
import Quizzes from 'es6/controllers/apps/quizzes';
import * as Result from 'es6/models/quiz-result';
import DiagnosticApp from 'es6/controllers/apps/diagnostic-app.js';
import * as ImageManager from 'es6/services/image-manager';

const Helpers = { Localization: { partOfSpeech } };

// Expose code to legacy.
Object.assign(window.App, { API, Errors, Helpers, ServerTimeManager });
Object.assign(window, { ImageManager, Localization, React, ReactDOM });
Object.assign(Smartfm.Apps.iKnow, { Quizzes })
Smartfm.Apps.QuizResult = Result;

$(document).ready(function(){
  new DiagnosticApp();
});
